// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	--black: #000;
	--white: #fff;
	--brand: #0f0;
	--gray: #f3f3f3;
	--gray2: #dfdfdf;
	--gray3: #666;
	--green: #38a126;

	--main-width: 700px;
	--main-padding-horizontal: 50px;
}
.yX3q33_aR6VwytrbNUjE {
	display: flex;
	flex-direction: column;
	position: relative;
}
@media not all and (max-width: 767px) {
.yX3q33_aR6VwytrbNUjE {
		justify-content: center;
		padding-bottom: 50px;
}
	}
@media not all and (max-width: 767px) {
	.dhg6ok1dSHJ52QlLYO4A {
		margin-left: 20px;
	}
}
.x5wmc3Ds2aBC2wdoZ2ei {
	border: none;
	border-bottom: 1px solid black;
	margin: 5px 0;
	width: 100%;
}
.TIcBnwu3gnKqf8yzDvQf {
	--container-width: calc(
		var(--main-width) - (var(--main-padding-horizontal) * 2)
	);

	bottom: 56px;
	left: calc(
		(100% - var(--container-width)) / 2 + var(--container-width) + 5px
	);
	margin-right: 10px;
	max-width: 370px;
	position: fixed;
}
.sev1sWSfvrpKsJWf53W1 {
	padding: 32px;
}
`, "",{"version":3,"sources":["webpack://./src/stylesheets/variables.pcss","webpack://./src/pages/CrossChainFarmPageV2/CrossChainFarmPageV2.pcss"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,aAAa;CACb,aAAa;CACb,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,gBAAgB;;CAEhB,mBAAmB;CACnB,+BAA+B;AAChC;ACRA;CACC,aAAa;CACb,sBAAsB;CACtB,kBAAkB;AAMnB;AAJC;AALD;EAME,uBAAuB;EACvB,oBAAoB;AAEtB;CADC;AAGD;CACC;EACC,iBAAiB;CAClB;AACD;AAEA;CACC,YAAY;CACZ,8BAA8B;CAC9B,aAAa;CACb,WAAW;AACZ;AAEA;CACC;;EAEC;;CAED,YAAY;CACZ;;EAEC;CACD,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;AAChB;AAEA;CACC,aAAa;AACd","sourcesContent":[":root {\n\t--black: #000;\n\t--white: #fff;\n\t--brand: #0f0;\n\t--gray: #f3f3f3;\n\t--gray2: #dfdfdf;\n\t--gray3: #666;\n\t--green: #38a126;\n\n\t--main-width: 700px;\n\t--main-padding-horizontal: 50px;\n}\n","@import './../../stylesheets/media-queries.pcss';\n@import './../../stylesheets/variables.pcss';\n\n.container {\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: relative;\n\n\t@media not all and (--mobile) {\n\t\tjustify-content: center;\n\t\tpadding-bottom: 50px;\n\t}\n}\n\n@media not all and (--mobile) {\n\t.farmDetails {\n\t\tmargin-left: 20px;\n\t}\n}\n\n.separator {\n\tborder: none;\n\tborder-bottom: 1px solid black;\n\tmargin: 5px 0;\n\twidth: 100%;\n}\n\n.hint {\n\t--container-width: calc(\n\t\tvar(--main-width) - (var(--main-padding-horizontal) * 2)\n\t);\n\n\tbottom: 56px;\n\tleft: calc(\n\t\t(100% - var(--container-width)) / 2 + var(--container-width) + 5px\n\t);\n\tmargin-right: 10px;\n\tmax-width: 370px;\n\tposition: fixed;\n}\n\n.content {\n\tpadding: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `yX3q33_aR6VwytrbNUjE`,
	"farmDetails": `dhg6ok1dSHJ52QlLYO4A`,
	"separator": `x5wmc3Ds2aBC2wdoZ2ei`,
	"hint": `TIcBnwu3gnKqf8yzDvQf`,
	"content": `sev1sWSfvrpKsJWf53W1`
};
export default ___CSS_LOADER_EXPORT___;
